<template>
  <div class="pdf-preview-wrapper">
    <canvas v-show="!error" ref="canvas" class="pdf-preview-canvas" />
    <div v-if="error" class="pdf-preview-error">
      <img
        src="https://storage.googleapis.com/neurohub-public-bucket/neurohub/public/assets/scrivi.jpg"
        alt="Anteprima non disponibile"
        class="product-image"
      />
    </div>
  </div>
</template>

<script>
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
import pdfjsWorker from "pdfjs-dist/legacy/build/pdf.worker.entry";

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

export default {
  name: "PdfPreview",
  props: {
    src: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      error: false,
    };
  },
  mounted() {
    this.renderFirstPage();
  },
  watch: {
    src() {
      this.error = false;
      this.renderFirstPage();
    },
  },
  methods: {
    async renderFirstPage() {
      if (!this.src) return;
      try {
        const pdf = await pdfjsLib.getDocument(this.src).promise;
        const page = await pdf.getPage(1);
        const canvas = this.$refs.canvas;
        const ctx = canvas.getContext("2d");

        const viewport = page.getViewport({ scale: 1 });
        const containerWidth = canvas.parentElement?.clientWidth || 200;
        const scale = containerWidth / viewport.width;
        const scaled = page.getViewport({ scale });

        canvas.width = scaled.width;
        canvas.height = scaled.height;

        await page.render({ canvasContext: ctx, viewport: scaled }).promise;
      } catch {
        this.error = true;
      }
    },
  },
};
</script>

<style scoped>
.pdf-preview-wrapper {
  width: 100%;
  height: 100%;
}
.pdf-preview-canvas {
  width: 100%;
  height: auto;
  display: block;
}
.pdf-preview-error {
  width: 100%;
}
</style>
